import * as React from 'react';
import { Paging } from './paging';
import { PagingArrows } from './paging-arrows';
import { PagingSelect } from './paging-select';

interface IPaginationProps {
    pagination: IPaginationOptions;
    onPageSelect(page: number): void;
    useRedux: boolean;
}

export interface IPaginationOptions {
    totalItems: number;
    pageSize: number;
    currentPage: number;
}

export interface IFullPaginationOptions extends IPaginationOptions {
    totalPages: number;
}

const DEFAULT_PAGE_SIZE = 10;

/// <summary>
/// Renders pagination arrows and buttons
/// </summary>
export class Pagination extends React.Component<IPaginationProps, any> {
    render() {
        // Guard against pageSize <= 0 or non-finite values — a bad CMS-side page size would
        // otherwise yield Infinity/NaN totalPages and freeze the tab in the paging button loop.
        let effectivePageSize = this.props.pagination.pageSize > 0
            ? this.props.pagination.pageSize
            : DEFAULT_PAGE_SIZE;
        let calculatedTotalPages = Math.ceil(this.props.pagination.totalItems / effectivePageSize);
        let boundedCurrentPage = this.props.pagination.currentPage > calculatedTotalPages
            ? calculatedTotalPages
            : this.props.pagination.currentPage;

        let fullPaginationOptions = {
            totalItems: this.props.pagination.totalItems,
            pageSize: effectivePageSize,
            currentPage: boundedCurrentPage,
            totalPages: calculatedTotalPages
        }

        return (
            <div className="pagination-wrapper">
                <div className={"search-pagination"}>
                    <PagingArrows paging={fullPaginationOptions} isLeftArrows={true} onPageSelect={this.props.onPageSelect} />

                    {/* Separate components for mobile and desktop pagination due to differing numbers of page buttons on each view*/}
                    <div className={"search-pagination-desktop"}>
                        <Paging paging={fullPaginationOptions} onPageSelect={this.props.onPageSelect} numberOfButtonsToShow={8} useRedux={this.props.useRedux} />
                    </div>

                    <div className={"search-pagination-mobile"}>
                        <Paging paging={fullPaginationOptions} onPageSelect={this.props.onPageSelect} numberOfButtonsToShow={6} useRedux={this.props.useRedux} />
                    </div>

                    <PagingArrows paging={fullPaginationOptions} isLeftArrows={false} onPageSelect={this.props.onPageSelect} />
                </div >
                <div className={"search-pagination-select"}>
                    <PagingSelect paging={fullPaginationOptions} onPageSelect={this.props.onPageSelect} value={""} id={"paging-select"} />
                </div >
            </div>
        );
    }
}
